import React, { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { ERROR, WARNING } from "../../services/common/Constants";
import i18next from "i18next";
import useStyles from "../../style/js-style/containers/administration/rules/RuleFormsStyle";
import EAAlert from "../EAAlert";
import _ from "lodash";
import { TargetFieldCategory } from "services/common/CalculatorUtils";
import { RuleType } from "services/common/RulesUtils";

const RuleActivationErrors = ({
  actionsListEmpty,
  noDossierSelected,
  hasEmptyRefs,
  multipleSameActionNotAllowed,
  onActionsListEmptyClose,
  onNoDossierSelectedClose,
  onEmptyRefsClose,
  onMultipleSameActionNotAllowedClose
}) => {
  const { classes } = useStyles();
  const [noCriteriaSelected, setNoCriteriaSelected] = useState(false);
  const [noDossierCriteriaSelected, setNoDossierCriteriaSelected] = useState(false);

  const criteria = useWatch({ name: 'criteria' });
  const ruleType = useWatch({ name: 'type' });

  useEffect(() => {
    if (ruleType === RuleType.ON_DOSSIER) {
      const hasAtLeastACriteria = !!criteria.find(x => x.targetField.target_field_category === TargetFieldCategory.DOSSIER)
      if (hasAtLeastACriteria) {
        setNoDossierCriteriaSelected(false)
      } else {
        setNoDossierCriteriaSelected(true)
      }
    }
  }, [criteria, ruleType])

  useEffect(() => {
    const hasAtLeastACriteria = !!criteria.find(x => !_.isEmpty(x.targetField))
    if (hasAtLeastACriteria) {
      setNoCriteriaSelected(false)
    } else {
      setNoCriteriaSelected(true)
    }
  }, [criteria])

  return (
    <>
      {noCriteriaSelected && (
        <EAAlert severity={WARNING} onClose={() => setNoCriteriaSelected(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeWarningColor}>
            <div>{i18next.t("rules.finalization.warningText1")}</div>
            <div className={classes.finalizeAlertWarning}>{i18next.t("rules.finalization.warningText2")}</div>
          </div>
        </EAAlert>
      )}
      {(noDossierCriteriaSelected && !noCriteriaSelected) && (
        <EAAlert severity={WARNING} onClose={() => setNoDossierCriteriaSelected(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeWarningColor}>
            <div>{i18next.t("rules.finalization.warningNoDossierCriterion")}</div>
            <div className={classes.finalizeAlertWarning}>{i18next.t("rules.finalization.warningNoDossierCriteriondetail")}</div>
          </div>
        </EAAlert>
      )}
      {actionsListEmpty && (
        <EAAlert severity={ERROR} onClose={() => onActionsListEmptyClose(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeErrorColor}>
            <div>{i18next.t("rules.finalization.actionsListEmpty")}</div>
          </div>
        </EAAlert>
      )}
      {noDossierSelected && (
        <EAAlert severity={ERROR} onClose={() => onNoDossierSelectedClose(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeErrorColor}>
            <div>{i18next.t("rules.finalization.noDossierSelected")}</div>
          </div>
        </EAAlert>
      )}
      {hasEmptyRefs && (
        <EAAlert severity={ERROR} onClose={() => onEmptyRefsClose(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeErrorColor}>
            <div>{i18next.t("rules.finalization.hasEmptyRefs")}</div>
          </div>
        </EAAlert>
      )}
      {multipleSameActionNotAllowed && (
        <EAAlert severity={ERROR} onClose={() => onMultipleSameActionNotAllowedClose(false)}>
          <div className={classes.finalizeAlertBloc + " " + classes.finalizeErrorColor}>
            <div>{i18next.t("rules.finalization.multipleSameActionNotAllowed")}</div>
          </div>
        </EAAlert>
      )}
    </>
  )

}

export default RuleActivationErrors
